<template>
  <div class="web-container">
    <!--页面顶部-->
    <a href="#" name="index"></a>
    <div class="content-container page-header">
      <div class="flex flex-dr flex-center">
        <div class="web-title flex flex-dr flex-center">
          <img :src="webConfig.logoUrl" alt="" class="logo">
          <span class="title">{{ webConfig.schoolName }}</span>
          <span class="title">{{ webConfig.systemName }}</span>
        </div>
      </div>
    </div>
    <!--顶部导航-->
    <nut-tabbar
        @tab-switch="tabSwitch3"
        :tabbar-list="navList"
        :bottom="true"
    >
    </nut-tabbar>
    <!--轮播图-->
    <div class="focus-container ">
      <nut-swiper class="swiper"
                  direction="horizontal"
                  :loop="true"
                  :autoPlay="2000"
                  :canDragging="false"
                  :paginationVisible="true"
                  ref="demo2"
      >
        <div v-for="(item,index) in webConfig.focusList" :key="index" class="nut-swiper-slide">
          <img :src="item.imgSrc" class="nut-img" alt=""/>
        </div>

      </nut-swiper>
    </div>
    <!--中心介绍-->
    <a href="#" name="center"></a>
    <div class="li-container content-container">
      <el-divider content-position="center" class="content-title">中心介绍</el-divider>
      <div class="content-html html-view">
        <p>新时代新征程，思政课建设如何展现新气象、实现新作为？习近平总书记指出，“思想政治理论课能否在立德树人中发挥应有作用，关键看重视不重视、适应不适应、做得好不好”，强调要“守正创新推动思政课建设内涵式发展，不断提高思政课的针对性和吸引力”。</p>
        <p>为深入贯彻落实习近平总书记关于思政课建设的重要指示批示精神，我校与成都智云鸿道信息技术有限公司深入合作，精心打造了思政课虚拟仿真体验教学中心，旨在借助现代信息技术的强大力量，为高校思政课改革创新注入新活力，将“有意义”的思政课讲得“有意思”，切实增强思政课的教学实效。</p>
        <p>中心依托学校特色学科，充分挖掘本地红色文化资源，精心构建思政虚拟仿真体验教学资源体系。中心现有中共一大、习近平总书记在湖北的足迹、铁路强国之路、工匠精神和中国共产党人的精神谱系系列虚拟仿真体验教学资源。学生通过这些资源，能够在逼真的三维场景中，凭借虚拟仿真技术与交互操作，身临其境地“体验历史”，并自主对历史现象和事件进行理性分析与判断，有效实现思政教育的育人目标。</p>
        <p>展望未来，中心将不断拓展数字思政教学资源，持续优化教学模式，进一步提升教师运用虚拟仿真技术开展思政教学的能力，努力将中心建设成为在区域内具有示范引领作用的思政课虚拟仿真体验教学基地，为培养德智体美劳全面发展的社会主义建设者和接班人贡献力量。</p>
      </div>
    </div>
    <!--项目介绍-->
    <a href="#" name="experiment"></a>
    <div class="content-container experiment-container">
      <el-divider content-position="center" class="content-title">项目介绍</el-divider>
      <!--实验介绍-->
      <div class="experiment-container flex flex-dr flex-center">
        <div class="list flex flex-dr flex-center">
          <div class="li" v-for="(experiment,experimentIndex) in experiments.list">
            <img :src="experiment.product_iconLeft" alt="" class="left-icon" v-if="experiment.product_iconLeft"
                 style="z-index: 1">
            <div class="bg">
              <img :src="experiment.product_bg" alt="">
            </div>
            <div class="info">
              <img class="avatar" :src="experiment.product_icon" alt="">
              <div class="title">{{ experiment.name }}</div>
              <div class="des-main word-hr ellipsis">{{ experiment.subName }}</div>
              <!--最多3行 每行18字 第三行超出省略号显示-->
              <div class="des word-hr ellipsis" v-html="experiment.description"></div>
              <div class="buttons">
                <a class="button" @click="ExperimentMethods().clickViewExperiment(experiment)">查看详情</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--产品介绍弹窗-->
    <nut-popup position="bottom" get-container="body" v-model="experimentInfo.dialog" :destroy-on-close="true" closeable
               close-icon="cross" close-icon-position="top-right"
               :style="{ height: '80%' }">
      <div class="experiment-dialog">
        <div class="header flex flex-dr flex-center"
             :style='"background-image: url("+experimentInfo.experiment.product_info_bg+")"'>
          <img :src="experimentInfo.experiment.product_icon" alt="" class="avatar">
          <div class="title">{{ experimentInfo.experiment.name }}</div>
          <div class="series-name">{{ experimentInfo.experiment.seriesName }}</div>
        </div>
        <div class="info-box">
          <div class="des">
            <div>实验简介：</div>
            <div class="view">
              <p v-for="p in experimentInfo.experiment.experimentDescription.split('\n')">{{ p }}</p>
            </div>
          </div>
          <div class="view-box">
            <!--todo 封面问题安卓和ios解决-->
            <div class="video-box" v-if="experimentInfo.experiment.product_video">
              <video id="v1" loop="" preload="auto" muted="" x-webkit-airplay="true" airplay="allow"
                     :poster="experimentInfo.experiment.name==='飞夺泸定桥'?'http://resouce.cdzyhd.com/6adb4edc-9226-4119-8419-366daff7e26a.png':''"
                     webkit-playsinline="true" playsinline="true" :src="experimentInfo.experiment.product_video"
                     class="video1 video"
                     draggable="true"></video>
              <img src="@/assets/icon/play.png" alt="" class="play-btn"
                   @click="e=>ExperimentMethods().playVideo(e)">
              <!--todo 加入全屏按钮-->
            </div>
            <el-image v-if="!experimentInfo.experiment.product_video&&experimentInfo.experiment.sample!==true" class="video-box-no" fit="cover"
                      :src="experimentInfo.experiment.product_info_img"
                      @click="window.open(experimentInfo.experiment.product_info_img)"></el-image>
            <div class="img-box flex flex-around flex-wrap" v-if="experimentInfo.experiment.sample!==true">
              <el-image
                  @click="window.open(experimentInfo.experiment.product_info_img_1)"
                  class="img"
                  fit="cover"
                  :src="experimentInfo.experiment.product_info_img_1">
              </el-image>
              <el-image
                  @click="window.open(experimentInfo.experiment.product_info_img_2)"
                  class="img"
                  fit="cover"
                  :preview-src-list="experimentDialogPicList"
                  :src="experimentInfo.experiment.product_info_img_2">
              </el-image>
              <el-image
                  @click="window.open(experimentInfo.experiment.product_info_img_3)"
                  fit="cover"
                  class="img"
                  :preview-src-list="experimentDialogPicList"
                  :src="experimentInfo.experiment.product_info_img_3">
              </el-image>
              <el-image
                  @click="window.open(experimentInfo.experiment.product_info_img_4)"
                  fit="cover"
                  class="img"
                  :preview-src-list="experimentDialogPicList"
                  :src="experimentInfo.experiment.product_info_img_4">
              </el-image>
            </div>
          </div>
        </div>
      </div>
    </nut-popup>
    <!--团队介绍-->
    <a href="#" name="member"></a>
    <div class="member-container content-container" v-if="false">
      <el-divider content-position="center" class="content-title">教学团队</el-divider>
      <div class="member-list">
        <nut-tab>
          <nut-tab-panel tab-title="思德法教研室">
            <div class="avatar-list flex flex-start flex-wrap">
              <div class="avatar-li" v-for="(item,index) in memberList[0]['list']" @click="clickMember(item,index)">
                <el-image
                    :src="item.avatar"
                    fit="scale-down"></el-image>
                <div class="name">{{ item.name }}（{{ item.duty }}）</div>
              </div>
            </div>
          </nut-tab-panel>
          <nut-tab-panel tab-title="概论教研室">
            <div class="avatar-list flex flex-start flex-wrap">
              <div class="avatar-li" v-for="(item,index) in memberList[1]['list']" @click="clickMember(item,index)">
                <el-image
                    :src="item.avatar"
                    fit="scale-down"></el-image>
                <div class="name">{{ item.name }}（{{ item.duty }}）</div>
              </div>
            </div>
          </nut-tab-panel>
        </nut-tab>
      </div>
    </div>
    <nut-popup position="bottom" get-container="body" v-model="member.dialog" :style="{ height: '80%' }"
               :destroy-on-close="true" closeable
               close-icon="cross" close-icon-position="top-right">
      <el-descriptions direction="vertical" :column="4" border class="member-dialog">
        <el-descriptions-item label="现任职务" :span="4">{{ member.info.duty }}</el-descriptions-item>
        <el-descriptions-item label="主授课程" :span="4">{{ member.info.course }}</el-descriptions-item>
        <el-descriptions-item label="研究方向" :span="4">{{ member.info.direction }}</el-descriptions-item>
        <el-descriptions-item label="主要社会兼职" :span="4">{{ member.info.socialDuty }}</el-descriptions-item>
        <el-descriptions-item label="简历" :span="4">
          <div v-html="member.info.history" class="word-hr history"></div>
        </el-descriptions-item>
        <el-descriptions-item label="承担课题/研究成果" :span="4">
          <div v-html="member.info.success" class="word-hr success"></div>
        </el-descriptions-item>
      </el-descriptions>
    </nut-popup>
    <!--友情链接-->
    <a href="#" name="link"></a>
    <div class="link-container content-container">
      <el-divider content-position="center" class="content-title">友情链接</el-divider>
      <div class="list flex flex-around flex-wrap">
        <div v-for="item in linkConfig.list" v-if="item.img" @click="clickLink(item)">
          <el-image :src="item.img" alt="" class="li" fit="contain"></el-image>
          <div class="name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <!--底部-->
    <div class="page-footer">
      <div class="info-container content-container">
        <div class="infos">
          <img :src="webConfig.logoUrl" alt="" class="logo">
          <p>{{ webConfig.webName }}</p>
          <p>主办：{{ webConfig.collegeName }}</p>
          <p>技术支持</p>
          <p>成都智云鸿道信息技术有限公司 </p>

          <p style="cursor: pointer" @click="window.open('https://beian.miit.gov.cn/')">{{
              webConfig.beiAnText
            }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import elDragDialog from "@/directive/el-drag-dialog";
import {isMobile, shareStart} from "../../utils/common";
import {WEB_URL} from "../../model/ConfigModel";
import {OfficialWebExperimentModel} from "../../model/OfficialWebExperimentModel";

export default {
  name: "web_hbtdyszyxy",
  directives: {
    elDragDialog
  },
  components: {},
  data() {
    return {
      window: window,
      navIndex: "",
      webConfig: {
        "logoUrl": "http://resouce.cdzyhd.com/4e22252c-c012-493f-8f67-1ffd001ced40.webp",
        "indexBannerUrl": "http://116.63.187.43:7035/files/20220720/216212798869344256.jpeg",
        "schoolName": "湖北铁道运输职业学院",
        "collegeName": "湖北铁道运输职业学院马克思主义学院",
        systemName: "思政课虚拟仿真体验教学中心",
        "focusList": [
          {imgSrc: "http://resouce.cdzyhd.com/2025-06-12/8969770b-61e0-43b3-9baa-9ecda32387c1.jpg"},
          {imgSrc: "http://resouce.cdzyhd.com/2025-06-12/e6e7731c-d8f9-43dc-8538-26d7d57d4169.jpg"},
          {imgSrc:"http://resouce.cdzyhd.com/80d7df8a-a188-4237-9837-d6b69fc8071f.png"},
          {imgSrc:"http://resouce.cdzyhd.com/709cc750-6d16-4d40-9489-6dfbdd528c51.png"},
          {imgSrc:"http://resouce.cdzyhd.com/4cc27a28-a598-46fa-adc3-4e3ae57550cd.png"}
        ],
        "webName": "湖北铁道运输职业学院思政课虚拟仿真体验教学中心",
        beiAnText: "蜀ICP备19034784号-1"
      },
      introduceConfig: {
        "tabs": [{
          "name": "中心简介",
          "showNav": true,
          "text": "",
          "id": "1661264029372"
        }, {
          "name": "教学团队",
          "showNav": true,
          "text": "",
          "id": "1661264039431"
        }], "name": "中心介绍"
      },
      experiments: {
        list: []
      },
      experimentInfo: {
        dialog: false,
        experiment: {
          experimentDescription: ""
        },
        list: []
      },
      experimentDialogPicList: [],
      memberActive: "1",
      memberList: [],
      member: {
        dialog: false,
        info: {}
      },
      linkConfig: {
        list: [
          {
            "id": 1661270247796,
            "img": "http://resouce.cdzyhd.com/673d852e-a2bf-48b3-8a8c-ca483bb6c1f1.jpg",
            "name": "湖北铁道运输职业学院",
            "url": "https://www.hcrt.edu.cn/"
          },
          {
            "id": 1662270247796,
            "img": "http://resouce.cdzyhd.com/d23cf15e-2e72-4e9f-8777-b23f55fb824c.png",
            "name": "成都智云鸿道",
            "url": "http://www.cdzyhd.com/"
          }
        ]
      },
      navList: [
        {
          'tabTitle': '中心介绍',
          'curr': false,
          'icon': 'http://img13.360buyimg.com/uba/jfs/t1/10361/35/4713/4643/5c0f3d62E437a3c94/273fd0fb90798f03.jpg',
          'activeIcon': 'http://img14.360buyimg.com/uba/jfs/t1/26604/35/1073/7896/5c0f3d61Eb9f5f184/5f01c938abe4216d.jpg',
          'href': '#center'
        },
        {
          'tabTitle': '项目介绍',
          'curr': false,
          'icon': 'http://img12.360buyimg.com/uba/jfs/t1/25443/23/1062/4600/5c0f3d61E2e9f1360/c9b3421fe18614e2.jpg',
          'activeIcon': 'http://img20.360buyimg.com/uba/jfs/t1/19241/12/1048/8309/5c0f3d61E17ed5a56/c3af0964cade47f8.jpg',
          'href': '#experiment'
        },
        {
          'tabTitle': '体验教学系统',
          'curr': false,
          'icon': 'http://resouce.cdzyhd.com/4c482680-6607-4c92-8dc4-4d36a7d73787.png',
          'activeIcon': 'http://resouce.cdzyhd.com/5d968a97-eefe-4058-8c0e-b5192ea4d7b6.png',
          'href': 'http://exp.cdzyhd.com/login?schoolId=258950417977708544'
        },
        // {
        //   'tabTitle': '教学团队',
        //   'curr': false,
        //   'icon': 'http://img20.360buyimg.com/uba/jfs/t1/20004/20/1045/3620/5c0f3d61Eaaec1670/9e59db63983b7b9f.jpg',
        //   'activeIcon': 'http://img14.360buyimg.com/uba/jfs/t1/23967/14/1072/6714/5c0f3d61E0ad8991e/8f741953f6e38f15.jpg',
        //   'href': '#member'
        // },
        {
          'tabTitle': '友情链接',
          'curr': false,
          'icon': 'http://resouce.cdzyhd.com/28d7cdf5-9c34-47e9-84dc-527e93cc0244.png',
          'activeIcon': 'http://resouce.cdzyhd.com/1e72c019-f242-4404-9467-fd14d4f69b24.png',
          'href': '#link'
        },
      ]
    }
  },
  created() {
    // 判断是不是在移动端
    if (!isMobile()) {
      window.location.href = WEB_URL + this.$route.path
    }
  },
  mounted() {
    this.getExperimentConfig()
    document.title = "湖北铁道运输职业学院思政课虚拟仿真体验教学中心"
    // 配置微信分享参数
    setTimeout(() => {
      // 判断是否在微信内
      // 思政教育春风化雨，立德树人启智润心更多精彩思政资源
      if (navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1) {
        shareStart(window.location.href, "湖北铁道运输职业学院思政课虚拟仿真体验教学中心", "工匠精神、中共一大、苏区精神、西柏坡精神、南泥湾精神、沂蒙精神、井冈山精神、伟大长征精神", "http://h5.exp.cdzyhd.com/images/logo/hbtdyszyxy.png")
      }
    }, 500)
  },
  methods: {
    // 获取产品配置
    async getExperimentConfig() {
      // 要获取的实验列表，和自定义属性
      let experimentList = [
        {
          "id": 1666665692980,
          "name": "极目楚天千帆竞（在鄂足迹）",
          "subName": "“极目楚天千帆竞（在鄂足迹）”虚拟仿真体验教学软件",
          "subName_h5": "“极目楚天千帆竞（在鄂足迹）”虚拟仿真体验教学软件",
          "description": "“极目楚天千帆竞（在鄂足迹）”虚拟仿真体验教学软件讲述党的十八大以来，习近平总书记始终心系荆楚儿女，先后五次来到湖北调研、考察，用心用情聆听人民心声，",
          "experimentDescription": "“极目楚天千帆竞（在鄂足迹）”虚拟仿真体验教学软件讲述党的十八大以来，习近平总书记始终心系荆楚儿女，先后五次来到湖北调研、考察，用心用情聆听人民心声，真情关切湖北发展，对湖北各项工作作出一系列重要部署，为湖北改革发展指明方向。\n\n项目引导学员贴近感受习近平总书记在湖北的嘱托，使湖北向着经济更好、结构更优、质量更高、后劲更足、实力更强稳健前行，荆山楚水在党的领导下充盈着高质量发展的澎湃动力。",
          "product_bg": "http://resouce.cdzyhd.com/2025-06-12/2ba47c63-7503-4cb8-8e90-bfea43f73f43.png",
          "product_icon": "http://resouce.cdzyhd.com/92534116-3a8a-4bba-ae48-eb9bb8bbbf25.png",
          "product_info_bg": "http://resouce.cdzyhd.com/514befe0-1f3c-4bf3-b9eb-499fc4487d13.jpg",
          "product_info_img": "http://resouce.cdzyhd.com/2025-06-12/2ba47c63-7503-4cb8-8e90-bfea43f73f43.png",
          "product_info_img_1": "http://resouce.cdzyhd.com/b0601669-c834-4e1a-88d1-022d2cc7625d.jpg",
          "product_info_img_2": "http://resouce.cdzyhd.com/b67a288d-d554-475b-8844-b64f536a4e3b.jpg",
          "product_info_img_3": "http://resouce.cdzyhd.com/d9af09c4-bdb5-452b-9a65-679aa73b7c14.jpg",
          "product_info_img_4": "http://resouce.cdzyhd.com/514befe0-1f3c-4bf3-b9eb-499fc4487d13.jpg"
        },
        {
          "id": 1666665692980,
          "name": "铁路强国之路",
          "subName": "铁路通，百业兴，铁路百年巨变见证复兴之路。",
          "subName_h5": "铁路通，百业兴，铁路百年巨变见证复兴之路。",
          "description": "铁路通，百业兴，铁路百年巨变见证复兴之路。中国凭借强大的基建能力和科技实力，已经建成世界最大的高速铁路网和先进的铁路网",
          "experimentDescription": "铁路通，百业兴，铁路百年巨变见证复兴之路。中国凭借强大的基建能力和科技实力，已经建成世界最大的高速铁路网和先进的铁路网，处处涌现出繁荣发展的活力。如今，神州大地上，铁路建设依然如火如荼，为加速构建现代化基础设施体系添砖加瓦。从蹒跚起步到领先世界，可以说，一部中国铁路发展史，也是一部民族复兴史的缩影。\n项目通过“5G+VR”等数字手段真实还原中国铁路百年来逐渐强盛的过程，展示了中国人自行设计和施工的第一条铁路干线——京张铁路以及“万里长江第一桥”武汉长江大桥、通达四方的中欧班列等里程碑成果和中国铁路的美好前景，学员在沉浸式的体验学习中感受中国铁路的历史变迁，感受中国铁路助力国民经济飞速发展的巨大作用，理解“铁路强国”的重要意义，坚信中国铁路这个“火车头”定能在畅通国内国际大循环新发展格局、服务中国式现代化建设中发挥更加重要支撑作用。",
          "product_bg": "http://resouce.cdzyhd.com/2025-06-12/e6e7731c-d8f9-43dc-8538-26d7d57d4169.jpg",
          "product_icon": "http://resouce.cdzyhd.com/aa578dc3-2f2e-4e2a-ab05-e84f2c8a346b.png",
          "product_info_bg": "http://resouce.cdzyhd.com/2025-06-12/69ddc6b9-bdad-4342-941e-f423363bf121.jpg",
          "product_info_img": "http://resouce.cdzyhd.com/2025-06-12/69ddc6b9-bdad-4342-941e-f423363bf121.jpg",
          "product_info_img_1": "http://resouce.cdzyhd.com/5292a37b-ad68-4a1c-8258-6adc879da65f.png",
          "product_info_img_2": "http://resouce.cdzyhd.com/b94a69d4-a997-4cc8-8c85-56416e8ff7a6.png",
          "product_info_img_3": "http://resouce.cdzyhd.com/66f660ff-d61c-4c6d-9184-57197bae1246.png",
          "product_info_img_4": "http://resouce.cdzyhd.com/6f417e4d-12f2-4082-af0c-6aa1a14d9a4d.png",

        },
        {
          "id": 1666665692980,
          "name": "工匠精神",
          "subName": "1950年，党和国家首次表彰劳动模范",
          "subName_h5": "1950年，党和国家首次表彰劳动模范。近一百年来，各条战线",
          "description": "1950年，党和国家首次表彰劳动模范。近一百年来，各条战线英雄辈出，群星灿烂。特别是党的十八大以来，我国工人阶级和广大劳",
          "experimentDescription": "1950年，党和国家首次表彰劳动模范。近一百年来，各条战线英雄辈出，群星灿烂。特别是党的十八大以来，我国工人阶级和广大劳动群众在实现中国梦伟大进程中拼搏奋斗、争创一流、勇攀高峰，为决胜全面建成小康社会、决战决胜脱贫攻坚发挥了主力军作用。\n\n该项目通过实验展现劳模精神在各个时期、各条战线所表现出的重要价值和时代特征，体现出甘祖昌、于敏等各劳模人物代表在怀揣着极高的爱国主义情怀之下，在极其艰难的条件和激烈的思想斗争下几乎不犹豫地选择去做看起来不可能完成的任务，让学员们去学习这种普通人又不普通的劳动意志与精神，激励他们争做新时代的奋斗者，实现自己的价值，共同投身于实现中华民族伟大复兴的宏伟事业中来。",
          "product_bg": "http://resouce.cdzyhd.com/994f206f-e89e-44f2-9cd2-5f83ff3fa0a4.jpg",
          "product_icon": "http://resouce.cdzyhd.com/74fd3125-2f5e-405e-a810-3a649fae062f.png",
          "product_info_bg": "http://resouce.cdzyhd.com/4abcd1a4-05fa-496d-8d05-a70db5edd4af.jpg",
          "product_info_img": "http://resouce.cdzyhd.com/b0a50f07-f839-447a-b8c5-d2203d0bf252.jpg",
          "product_info_img_1": "http://resouce.cdzyhd.com/8a39a28a-2e9b-4a2c-8ba4-838eefcd00ec.jpg",
          "product_info_img_2": "http://resouce.cdzyhd.com/97a9d12c-e898-436a-875a-4aa4c23f6207.jpg",
          "product_info_img_3": "http://resouce.cdzyhd.com/5a103169-f358-4c33-85e5-e59dbdfc1ac8.jpg",
          "product_info_img_4": "http://resouce.cdzyhd.com/21924795-5022-4cf4-833f-d28a391003a7.jpg"
        },
        {id: "1618478479657", name: "中共一大"},

        {id: "1666668501569", name: "伟大建党精神"},
        {id: "1666668512034", name: "苏区精神"},
        {id: "1666668526771", name: "西柏坡精神"},
        {id: "1666668539421", name: "南泥湾精神"},
        {id: "1666668541545", name: "沂蒙精神"},
        {id: "1666668552526", name: "井冈山精神"},
        {id: "1666668563254", name: "伟大长征精神"},
        {id: "1666668561049", name: "伟大抗战精神"},
        {id: "1666668571403", name: "“两弹一星”精神"},
        {id: "1666668576144", name: "大庆精神"},
        {id: "1666668588955", name: "塞罕坝精神"},
        {id: "1666668595255", name: "抗美援朝精神"},
        {id: "1666668600599", name: "焦裕禄精神"},
        {id: "1666668613657", name: "雷锋精神"},
        {id: "1666668626825", name: "特区精神"},
        {id: "1666668631013", name: "载人航天精神"},
        {id: "1666668640306", name: "伟大抗疫精神"},
      ]
      let list = []
      for (let i = 0; i < experimentList.length; i++) {
        let id = experimentList[i]["id"]
        let experiment = await OfficialWebExperimentModel.getOneExperimentConfig(id)
        let experimentLast=Object.assign({},experiment,experimentList[i])
        // 合并自定义项
        list.push(experimentLast)
        this.$set(this.experiments, "list", list)
      }
    },
    tabSwitch3: function (value, index) {
      console.log(index);
    },
    // 点击首页导航
    selectNav(v) {
      switch (v) {
        case "1":
          window.location.href = "#center"
          break;
        case "2":
          window.location.href = "#experiment"
          break;
        case "3":
          window.location.href = "#member"
          break;
        case "4":
          window.location.href = "#link"
          break;
        case "5":
          window.location.href = ""
          break;
      }
    },
    // 点击团队成员
    clickMember(item, index) {
      this.$set(this.member, "info", item)
      this.member.dialog = true
    },
    // 点击友情链接
    clickLink(item) {
      window.open(item.url)
    },
    // 实验项目方法集
    ExperimentMethods() {
      let $this = this;
      return {
        clickViewExperiment(experiment) {
          $this.experimentInfo.dialog = true
          $this.experimentDialogEnterBtn = false
          $this.$set($this.experimentInfo, "experiment", experiment);
          $this.experimentDialogPicList = [
            experiment.product_info_img_1,
            experiment.product_info_img_2,
            experiment.product_info_img_3,
            experiment.product_info_img_4,
          ]
          if (!experiment.product_video && experiment.product_info_img) {
            $this.experimentDialogPicList.push(experiment.product_info_img)
          }
          setTimeout(() => {
            $(".experiment-dialog .bg").css("background-image", `url(${experiment.product_info_bg})`)
          }, 100)
        },
        // 播放视频
        playVideo(e) {
          // this.videoPlay = true
          // document.querySelector("#v1").play()
          $this.experimentInfo.experimentVideoDialog = true
        }
      }
    }
  }
}
</script>
<style>
.nut-tab {
  padding: 0px !important;
  border: 0px !important;
  overflow-y: hidden;
}

.nut-tab-item {
  height: auto !important;
  padding: 0px !important;
}

.nut-tab-link {
  font-size: 27px !important;
}

.nut-tabbar .tabbar-nav:nth-child(3) .tabbar-nav-word {
  color: #de201a !important;
}
</style>
<style scoped lang="less">
@import '../../style/app.less';

.web-container {
  //background-color: #f2f2f2;
}

.content-title {
  margin-top: 40px;

  .el-divider__text {
    font-size: 40px;
    color: #777;
    font-weight: 450;
    text-align: center;
    margin-bottom: 20px;
  }

}

.page-header {
  width: 100%;
  background-color: #fff;
  z-index: 1999;

  .web-title {
    margin-top: 20px;

    .logo {
      width: 120px;
      height: 120px;
      cursor: pointer;
      display: block;
      margin-bottom: 15px;
    }

    span.title {
      font-size: 40px;
      color: #666;
      font-weight: bold;
      margin-bottom: 10px;
    }
  }
}

.focus-container {
  margin-top: 30px;
  margin-bottom: 60px;

  .swiper {
    height: 550px;
  }

  .nut-img {
    object-fit: cover;
    height: 550px;
  }
}

.li-container {
  margin-bottom: 50px;

  .content-html {
    margin-top: 45px;
    padding: 0px 20px;
    text-indent: 2em;
    font-size: 28px;
    color: #666;
    line-height: 40px;
    letter-spacing: 3px;
  }
}

// 实验介绍
.experiment-container {
  margin-bottom: 100px;

  .main-title {
    margin-top: 83px;
    font-size: 36px;
    font-weight: bold;
    line-height: 46px;
    color: #333333;
  }

  .title-des {
    font-size: 28px;
    font-weight: 300;
    line-height: 37px;
    color: #333333;
    margin-top: 20px;
    margin-bottom: 60px;
  }

  .list {
    width: 670px;
    align-items: normal;

    .li {
      margin-bottom: 40px;
      position: relative;

      &:hover {
        .bg {
          img {
            transition: all 0.5s linear;
            transform: scale(1.1);
          }
        }

        .info {
          box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);

          .avatar {
            margin-top: -40px;
            opacity: 0;
          }

          .des-main {
            opacity: 0;
          }

          .title {
            margin-top: -60px;
          }

          .des {
            display: -webkit-box;
          }

          .buttons {
            display: block;
          }
        }
      }

      img.left-icon {
        position: absolute;
        width: 120px;
        height: 120px;
        top: -10px;
        left: -10px;
        z-index: 10;
      }

      .bg {
        z-index: 1;
        width: 670px;
        height: 413px;
        overflow: hidden;

        img {
          width: 670px;
          height: 413px;
          display: block;
          transition: all 0.5s linear;
          transform: scale(1);
        }
      }

      .info {
        position: relative; // 解决margin-top负数 和同级div的z-index问题
        padding: 30px;
        height: 415px;
        width: 590px;
        margin: 0 auto;
        margin-top: -60px;
        text-align: center;
        background: #fff;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        border-bottom: 3px solid transparent;
        transition: all 0.2s linear;

        .avatar {
          display: inline-block;
          width: 148px;
          height: 148px;
          position: relative;
          margin-top: 60px;
          transition: all 0.2s linear;
          box-shadow: 1px 3px 6px 2px #dedede;
        }

        .title {
          position: relative;
          font-size: 36px;
          font-weight: bold;
          margin-top: 30px;
          margin-bottom: 8px;
          transition: all 0.2s linear;
          line-height: 46px;
        }

        .des-main {
          font-size: 28px;
          line-height: 35px;
          transition: all 0.2s linear;
          color: #666;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          display: -webkit-box;
        }

        .des {
          font-weight: 300;
          font-size: 29px;
          display: none;
          color: #666;
          line-height: 35px;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }

        .buttons {
          display: none;
          text-align: center;
          margin-top: 15px;
        }

        .button {
          display: inline-block;
          width: 200px;
          line-height: 56px;
          border: 1px solid #d8d8d8;
          border-radius: 15px;
          text-align: center;
          font-size: 24px;
          color: #666666;
          position: relative;
          cursor: pointer;
          transition: all 0.2s linear;
          text-decoration: none;
          padding: 5px 20px;
          margin-top: 20px;

          &:hover {

          }
        }


      }
    }

    .li:last-child {
      margin-bottom: 0px;
    }
  }

  .more {
    text-align: center;
    cursor: pointer;
    transition: all 0.3s linear;
    width: 300px;
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 30px;
    color: #707070;

    &:hover {
      transform: scale(1.1);
    }

    span {
      font-weight: 400;
      line-height: 21px;
      color: #999999;
      font-size: 32px;

    }

    i {
      margin-left: 10px;
    }
  }
}

.experiment-dialog {
  .header {
    width: 750px;
    height: 530px;
    background-size: cover;
    background-position: 50% 50%;
    -webkit-backface-visibility: hidden;

    .avatar {
      width: 178px;
      height: 178px;
    }

    .title {
      margin-top: 10px;
      font-size: 32px;
      font-weight: bold;
      line-height: 42px;
      color: #FFFFFF;
      text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
      opacity: 0.9;
    }

    .series-name {
      font-size: 28px;
      font-weight: 400;
      line-height: 37px;
      color: #FFFFFF;
      text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
      opacity: 0.9;
      margin-top: 10px;
    }

  }

  .info-box {
    padding: 20px 40px;
    font-size: 28px;
    font-weight: 400;
    line-height: 37px;
    color: #333333;

    .view {
      margin-top: 10px;
      font-size: 28px;
      font-weight: 400;
      line-height: 40px;
      color: #333333;
      text-indent: 2em;
    }

    .view-box {
      width: 100%;
      margin-top: 25px;
      margin-bottom: 65px;

      .video-box {
        width: 670px;
        height: 360px;
        position: relative;

        video {
          position: absolute;
          left: 0;
          top: 0;
          width: 670px;
          height: 360px;
          object-fit: fill;
          z-index: 1;
        }

        .play-btn {
          position: absolute;
          // 上下左右居中
          left: 50%;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
          width: 108px;
          height: 108px;
          cursor: pointer;
          z-index: 2;
        }
      }

      .video-box-no {
        width: 670px;
        height: 360px;
        background-size: cover;
        background-position: 50% 50%;
        -webkit-backface-visibility: hidden;
      }

      .img-box {
        margin-top: 10px;

        .img {
          width: 330px;
          height: 105px;
          cursor: pointer;

          &:nth-child(1), &:nth-child(2) {
            margin-bottom: 11px;
          }
        }
      }
    }
  }
}

.member-list {
  margin: 0 auto;
  margin-top: 50px;
  margin-bottom: 55px;
  width: 100%;

  .title {
    margin-bottom: 20px;
    color: #555;
    font-size: 25px;
  }

  .avatar-list {
    padding-top: 20px;
    text-align: center;
    display: grid;
    justify-content: space-between;
    grid-template-columns: repeat(auto-fill, 360px);

    .avatar-li {
      width: 360px;
      margin-bottom: 30px;

      .el-image {
        width: 360px;
        height: 360px;
        background-size: cover;
        background-position: 50% 50%;
        -webkit-backface-visibility: hidden;
        opacity: 1;
        transform: scale(1);
        cursor: pointer;
      }

      .name {
        width: 360px;
        text-align: center;
        margin-top: 15px;
        color: #888;
        font-size: 26px;
      }
    }
  }
}

.member-dialog {
  text-align: left;
  font-size: 28px;
  color: #888;
}

// 友情链接
.link-container {
  margin-bottom: 45px;
  padding: 0px 30px;

  .list {
    margin-top: 60px;
    text-align: center;
    display: grid;
    justify-content: space-between;
    grid-template-columns: repeat(auto-fill, 320px);
    grid-gap: 10px;

    .name {
      margin-top: 10px;
      color: #777;
      font-size: 26px;
    }
  }


  .li {
    width: 320px;
    height: 160px;
    margin-top: 10px;
    //margin-right: 10px;
    background-size: cover;
    background-position: 50% 50%;
    -webkit-backface-visibility: hidden;
    opacity: 1;
    transform: scale(1);
    border-radius: 4px;
    cursor: pointer;
    box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.1);

    &:hover {
      transition: all 0.3s linear;
      transform: scale(1.03);
    }
  }
}

.page-footer {
  background-color: #2d2d2d;
  padding: 20px 0px;
  padding-bottom: 35px;
  margin-bottom: 135px;

  .info-container {
    .logo {
      width: 70px;
      height: 70px;
      cursor: pointer;
      display: none;
    }

    .infos {
      text-align: center;
      color: @remark-color;
      font-size: 24px;

      span {
        margin-right: 10px;
      }
    }
  }
}
</style>
